export default "__VITE_ASSET__iF7_mGhk__"